// models/user
import ES6 from 'es6-promise'
ES6.polyfill()
import 'isomorphic-fetch'
import config from '../../config/public'
export default {
  get(params, callback) {
    const endpoint = `${config.rechat_host}/users/self`
    fetch(endpoint, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + params.access_token
      }
    })
    .then(response => {
      if (response.status >= 400) {
        return callback(response, null)
      }
      return response.json()
    })
    .then(response => {
      return callback(null, response)
    })
  }
}


// WEBPACK FOOTER //
// ./src/models/User.js